module.exports = __webpack_public_path__ + "img/22.fff67c36.jpg";